export const USE_COMPANY_EMPLOYEES = 'USE_COMPANY_EMPLOYEES';
export const USE_COUNT_DIVISION_MEMBER = 'USE_COUNT_DIVISION_MEMBER';
export const USE_COUNT_BRANCH_MEMBER = 'USE_COUNT_BRANCH_MEMBER';
export const USE_DEPARTMENT_DIAGRAM = 'USE_DEPARTMENT_DIAGRAM';
export const USE_SKILL_DIAGRAM = 'USE_SKILL_DIAGRAM';

export const NOT_VIEW = 'none';
